<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadStationList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="stationList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="工位名称" prop="name"></el-table-column>
      <el-table-column label="工位面积" width="80" prop="area"></el-table-column>
      <el-table-column label="工位数量" width="80" prop="workNum"></el-table-column>
      <el-table-column label="状态" width="80">
        <template #default="{row}">
          <div>{{row.status | status}}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
      <el-table-column label="创建人" prop="creatorName"></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>

      <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteStation(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <edit-station-dialog :visible.sync="dialog.show"
                         :station="dialog.station"
                         :read-only="readOnly">
    </edit-station-dialog>
  </div>
</template>

<script>
  import EditStationDialog from '@/views/station/EditStationDialog'
  import { Station } from '@/store/objdef/objectDef'
  import authority from '@/utils/authority'

  export default {
    name: 'StationList',
    components: { EditStationDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          station: new Station()
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('station/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.station = new Station()
        this.dialog.show = true
      },
      edit (station) {
        this.dialog.station = this.$_.cloneDeep(station)
        this.dialog.show = true
      },
      deleteStation (station) {
        this.$confirm(`确认删除工位【${station.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('station/delete', station.id).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadStationTemplate'
      },
      stationList () {
        const list = this.$store.state.station.stationList
        if (!this.searchText) return list

        return list.filter(station => station.name.indexOf(this.searchText) !== -1)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_STATION)
      },
      addable () {
        return this.$hasPermission(authority.ADD_STATION)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_STATION)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
